export const STATUS_PENDING = ['Pending'];
export const STATUS_EVALUATED = ['Evaluated'];
export const STATUS_CORRECT = ['Correct', '1'];
export const STATUS_INCORRECT = ['Incorrect', '0'];
export const STATUS_SKIPPED = ['Skipped', '2'];
export const STATUS_PARTIAL = ['Partial'];
